import { MFAStatus, PostLoginMFAResponse } from '@ld.consumer-portal/models';

const MFA_REMEMBER_DEVICE_KEY = 'mock_mfa_remember_device';

export function getMfaRememberDeviceStatus(): 'valid-device' | null {
  const stored = localStorage.getItem(MFA_REMEMBER_DEVICE_KEY);
  if (stored === 'true') {
    return 'valid-device';
  }
  return null;
}

export function setMfaRememberDevice(remember: boolean): void {
  if (remember) {
    localStorage.setItem(MFA_REMEMBER_DEVICE_KEY, 'true');
  } else {
    localStorage.removeItem(MFA_REMEMBER_DEVICE_KEY);
  }
}

export function clearMfaRememberDevice(): void {
  localStorage.removeItem(MFA_REMEMBER_DEVICE_KEY);
}

export const mfaMockResponses: Record<string, PostLoginMFAResponse> = {
  'mfa-required': {
    isSuccess: true,
    message: 'MFA verification required',
    mfaStatus: MFAStatus.Process,
    emailIds: [
      { key: 'mock_email_key_1', value: 'mock_user******@gmail.com' },
      { key: 'mock_email_key_2', value: 'mock_john******@yahoo.com' },
    ],
    phoneNumbers: [
      { key: 'mock_phone_key_1', value: 'mock_***-***-2261' },
      { key: 'mock_phone_key_2', value: 'mock_***-***-5678' },
    ],
  },

  'mfa-email-only': {
    isSuccess: true,
    message: 'MFA verification required',
    mfaStatus: MFAStatus.Process,
    emailIds: [{ key: 'mock_email_key_1', value: 'mock_user******@gmail.com' }],
    phoneNumbers: [],
  },

  'mfa-phone-only': {
    isSuccess: true,
    message: 'MFA verification required',
    mfaStatus: MFAStatus.Process,
    emailIds: [],
    phoneNumbers: [{ key: 'mock_phone_key_1', value: 'mock_***-***-2261' }],
  },

  'valid-device': {
    isSuccess: true,
    message: 'Device validated',
    mfaStatus: MFAStatus.ValidDevice,
    emailIds: [],
    phoneNumbers: [],
  },

  skip: {
    isSuccess: true,
    message: 'MFA skipped',
    mfaStatus: MFAStatus.Skip,
    emailIds: [],
    phoneNumbers: [],
  },

  'link-loan': {
    isSuccess: true,
    message: 'Please link your loan',
    mfaStatus: MFAStatus.LinkLoan,
    emailIds: [],
    phoneNumbers: [],
  },

  'mla-not-found': {
    isSuccess: false,
    message: 'User not found in servicing',
    mfaStatus: MFAStatus.Process,
    emailIds: [],
    phoneNumbers: [],
  },

  error: {
    isSuccess: false,
    message: 'An error occurred while processing MFA',
    mfaStatus: MFAStatus.Skip,
    emailIds: [],
    phoneNumbers: [],
  },
};

export const mfaVerifyMockResponses = {
  success: {
    success: true,
    message: 'Code verified successfully',
  },
  'invalid-code': {
    success: false,
    message: 'Invalid verification code',
  },
  'expired-code': {
    success: false,
    message: 'Verification code has expired',
  },
  'max-attempts': {
    success: false,
    message: 'Maximum verification attempts exceeded',
  },
};
